import { useJsonResource } from './use-json-resource';

/**
 * The `calculate*` functions exported by the NPM package for a version, from the
 * sdk-calculators.json manifest written at build time.
 */
export function useSdkCalculators(urlVersion: string | undefined) {
  const { loading, error, data } = useJsonResource<string[]>(urlVersion, 'sdk-calculators.json');
  return { loading, error, calculators: data };
}
